import { MemberFormRule, MemberFormSchema } from "@factory/form/form.rule";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import "./form-member-wrapper.scss";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { memberFormDefault } from "@factory/form/form.default";
import { forwardRef, useImperativeHandle, useEffect } from "react";
import FormMember from "../form-member/form-member";

export interface FormMemberWrapperProps {
  isChild?: boolean;
  onSubmit: (data: MemberFormSchema) => void;
  defaultValues?: Partial<MemberFormSchema>;
  onChange?: (data: MemberFormSchema) => void;
}
export interface FormMemberWrapperRef {
  triggerSubmit: () => void;
}

type InputFormSchema = MemberFormSchema;
export function FormMemberWrapper(
  props: FormMemberWrapperProps,
  ref: React.Ref<FormMemberWrapperRef>
) {
  const formMethod = useForm<InputFormSchema>({
    defaultValues: {
      ...memberFormDefault,
      ...props.defaultValues,
    },
    resolver: zodResolver(
      MemberFormRule.superRefine((val, ctx) => {
        if (!props.isChild && val.mobileNumber === "") {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `Mobile is required`,
            path: ["mobileNumber"],
          });
        }
        // if (props.isChild && val.birthday === "") {
        //   ctx.addIssue({
        //     code: z.ZodIssueCode.custom,
        //     message: `Birthday is required`,
        //     path: ["birthday"],
        //   });
        // }
      })
    ),
  });
  const { handleSubmit, watch } = formMethod;

  useImperativeHandle(ref, () => ({
    triggerSubmit: () => handleSubmit(submitHandler)(),
  }));

  const submitHandler: SubmitHandler<InputFormSchema> = (data) => {
    props.onSubmit(data);
  };

  const values = watch();
  const onChange = props.onChange;

  useEffect(() => {
    if (onChange) {
      onChange(values);
    }
  }, [values, onChange]);

  return (
    <div id="FormMemberWrapper" className="form-member-wrapper">
      <FormProvider {...formMethod}>
        <FormMember isChild={props.isChild} />
      </FormProvider>
    </div>
  );
}

export default forwardRef(FormMemberWrapper);
